<template>
  <div class="transformer-tab">
    <div>
      <b-checkbox
        class="transformer-tab__title mt-0"
        :checked="isAllFieldsSelected('generalData')"
        @change="toggleAll($event, 'generalData')"
      >
        {{ $t('asset-information.menu.general-data') }}
      </b-checkbox>
    </div>
    <b-checkbox-group
      class="transformer-tab__checkbox-group"
      v-model="selectedFieldsProxy"
      :options="fields.generalData"
    />
    <div>
      <b-checkbox
        class="transformer-tab__title"
        :checked="isAllFieldsSelected('losses', true)"
        @change="toggleAll($event, 'losses', true)"
      >
        {{ $t('asset-information.menu.losses') }}
      </b-checkbox>
    </div>
    <b-checkbox-group
      class="transformer-tab__checkbox-group"
      v-model="selectedFieldsProxy"
      :options="generalLossesOptions"
    />
    <fieldset class="transformer-tab__fieldset">
      <legend class="transformer-tab__legend">
        {{ $t('asset-information.asset-info.losses.short-circuit-losses') }}
      </legend>
      <b-checkbox-group
        class="transformer-tab__checkbox-group"
        v-model="selectedFieldsProxy"
        :options="shortCircuitLossesOptions"
      />
    </fieldset>
  </div>
</template>

<script>
import transformerTabFields from '@/domain/data/generalPanel/reports/additionalFields/transformerTabFields';
import additionalFieldsTabMixin from '@/domain/data/generalPanel/reports/additionalFields/additionalFieldsTabMixin';

export default {
  name: 'TransformerTab',
  mixins: [additionalFieldsTabMixin],
  props: {
    selectedFields: {
      type: Array,
      default: () => ([]),
    },
  },
  data: vm => ({
    fields: transformerTabFields(vm),
  }),
  computed: {
    shortCircuitLossesOptions() {
      const losses = this.fields.losses || {};
      return losses.shortCircuitLosses;
    },
    generalLossesOptions() {
      const losses = this.fields.losses || {};
      return losses.general;
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"

.transformer-tab
  max-height: 57vh
  overflow-y: auto
  &__fieldset
    margin: 0 10px
    padding: 5px 0
    border: 1px solid $color-border-gray
    border-radius: 3px
    .transformer-tab__checkbox-group ::v-deep
      .custom-control.custom-control-inline.custom-checkbox
        width: 225px
  &__legend
    font-size: 1rem
    font-weight: bold
    margin-left: 10px
    padding: 0 5px
    margin-bottom: 0
    width: auto
  &__title
    background-color: var(--color-background-dark)
    color: var(--font-color-primary)
    padding-left: 30px
    max-height: unset
    height: 30px
    margin: 10px 0
    display: flex
    align-items: center
  &__checkbox-group
    margin-left: 9px
    ::v-deep
      .custom-control.custom-control-inline.custom-checkbox
        width: 230px
      .custom-control-label
        font-weight: normal
      > div
        min-height: 50px
        max-height: unset
        align-items: center
</style>
